import { render, staticRenderFns } from "./ExpiredInactiveUsersExport.vue?vue&type=template&id=2bbcd398&scoped=true"
import script from "./ExpiredInactiveUsersExport.vue?vue&type=script&lang=js"
export * from "./ExpiredInactiveUsersExport.vue?vue&type=script&lang=js"
import style0 from "./ExpiredInactiveUsersExport.vue?vue&type=style&index=0&id=2bbcd398&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbcd398",
  null
  
)

export default component.exports